import { addImageParams, getAdQuestionUrl, getSellerUrl } from '@/utils/urls';
import { AdUnit } from '@/redux/modules/catalog/ad/catalogAd.types';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { WeakLink } from '@liveauctioneers/hammer-ui-core/link';
import isEqual from 'react-fast-compare';
import React from 'react';
import styled from 'styled-components';

type Props = React.PropsWithChildren<{
    adUnit: AdUnit;
    className: string;
    scrolled: boolean;
    stick: boolean;
    stickBottom: boolean;
    trackClick: (event: React.SyntheticEvent) => void;
}>;

const ConsignmentAd = (props: Props) => {
    const { adUnit, children, className, scrolled, stick, stickBottom, trackClick } = props;
    const { destination, imageUrl1, sellerId = 0, sellerName = '' } = adUnit;

    let style: { [attribute: string]: string | number } =
        stick && scrolled ? { marginLeft: 12.5, marginRight: 12.5, position: 'fixed', top: 0 } : {};
    if (stickBottom && scrolled) {
        style = {
            bottom: 0,
            marginLeft: 12.5,
            marginRight: 12.5,
            position: 'absolute',
        };
    }

    const to = destination || `${getSellerUrl(sellerId, sellerName)}?consign=true`;

    return (
        <StyledConsignmentAdWrapper
            onClick={trackClick}
            style={style}
        >
            <StyledConsignmentAd className={className}>
                <WeakLink href={to}>
                    <img
                        alt={sellerName}
                        loading="lazy"
                        src={addImageParams({ url: imageUrl1 })}
                    />
                </WeakLink>
            </StyledConsignmentAd>
            <StyledYourAdHere>
                <FormattedMessage id="advertisement" />{' '}
                <WeakLink
                    href={getAdQuestionUrl()}
                    size="xs"
                    target="_blank"
                >
                    <FormattedMessage id="your_ad_here" />
                </WeakLink>
            </StyledYourAdHere>
            {children}
        </StyledConsignmentAdWrapper>
    );
};

export default React.memo<Props>(ConsignmentAd, isEqual);

const StyledConsignmentAdWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-top: 20 px;
`;

const StyledConsignmentAd = styled.div`
    width: 182px;
    height: 643px;
    border: solid 1px ${({ theme }) => theme.colors.grey400};

    img {
        display: block;
    }
`;

const StyledYourAdHere = styled.div`
    width: 180px;
`;
